export const VIRUS_SCAN_STATUS = {
  QUEUED: 'VIRUS_SCAN_QUEUED',
  INFECTED: 'VIRUS_SCAN_INFECTED',
  CLEAN: 'VIRUS_SCAN_CLEAN',
};

export default VIRUS_SCAN_STATUS;
